//Send user update / create user request

async function UpdateUser(userid, useridtoupdate, password, token, firstname, lastname, email, isadmin, mustchangepassword) {

    if (
        userid != null &&
        token != null &&
        firstname != null &&
        lastname != null &&
        email != null &&
        isadmin != null &&
        mustchangepassword != null
    ) {

        let response;

        response = await fetch("https://api.cssi.co/login/updateuser", {
            method: "POST",
            body: JSON.stringify(
                {
                    "userid": userid,
                    "userIdToUpdate": useridtoupdate,
                    "password": password,
                    "token": token,
                    "firstName": firstname,
                    "lastName": lastname,
                    "email": email,
                    "isAdmin": isadmin,
                    "mustChangePassword": mustchangepassword
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default UpdateUser;


